<script lang="ts">
  import { onMount } from "svelte";
  import cfg from "$lib/config/config";
  import { recommendations } from "$lib/stores/recommendations";

  onMount(() => {
    recommendations.handleNoTracking();
    recommendations.getSessionParams();
  });
</script>

<svelte:head>
  {#if cfg.NOSTO_ACCOUNT_ID && cfg.NOSTO_ACCOUNT_ID !== ""}
    <script type="text/javascript">
      (() => {
        window.nostojs =
          window.nostojs ||
          (cb => {
            (window.nostojs.q = window.nostojs.q || []).push(cb);
          });
      })();
    </script>
    <script type="text/javascript">
      nostojs(api => api.setAutoLoad(false));
    </script>
    <script
      src={`//connect.nosto.com/include/${cfg.NOSTO_ACCOUNT_ID}`}
      async
    ></script>
  {/if}
</svelte:head>
